import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AnnouncementBar(): React.ReactElement | null {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="announcement-bar" role="banner">
      <span>
        CBAM full enforcement begins January 2026 &mdash; is your embedded carbon data ready?{' '}
        <Link to="/platform#cbam">See how Actula helps &rarr;</Link>
      </span>
      <button
        className="bar-close"
        aria-label="Dismiss announcement"
        onClick={() => setDismissed(true)}
      >
        &times;
      </button>
    </div>
  );
}
